import React, { Component } from 'react'
import { uniq } from 'lodash'
import './estimationExtent.scss'

// Utils
import EventEmitter from '../../../../../utils/events'
import { translation } from '../../../../../utils/helpers'

// Elements
import Check from '../../../../elements/check'
import Divider from '../../../../elements/divider'
// import Expand from '../../../../elements/expand'

// Components
import ForsiLine from '../../ForsiLine'
import AssessmentForsiLine from '../../AssesmentForsiLine'
import EstimationLine from '../../EstimationLine'
import AssessmentReportSums from '../../AssessmentReportSums'

class EstimationExtents extends Component {
  constructor (props) {
    super(props)
    this.state = {
      price: this.props.orderPrice !== undefined ? this.props.orderPrice : null,
      partTasks: this.props.partTasks !== undefined ? this.props.partTasks : null,
      accordions: {
        refinish0: false,
        refinish1: false,
        refinish2: false,
        refinish3: false,
        refinish4: false,
        refinish5: false,
        starttime1: false,
        starttime2: false,
        starttime3: false,
        starttime4: false,
        hourlyprice: false,
        materialshare: false
      }
    }
  }

  componentDidMount () {
    this.componentWillReceiveProps(this)
  }

  componentWillReceiveProps (next) {
    if (next.orderPrice === undefined && next.partTasks === undefined) return
    let orderPrice = this.state.price
    let partTasks = this.state.partTasks
    if (next.orderPrice !== undefined) orderPrice = next.orderPrice
    if (next.partTasks !== undefined) partTasks = next.partTasks

    // Allow override ForsiReport object used.
    if (orderPrice !== null && orderPrice.Report === null && this.props.forsiReport !== undefined) {    // Looks like this never happens???
      orderPrice.Report = this.props.forsiReport
    }
    this.setState({
      price: orderPrice,
      partTasks: partTasks
    })
  }

  toggleOpen (name) {
    if (this.props.editable !== true) return
    this.setState({
      accordions: {
        ...this.state.accordions,
        [name]: !this.state.accordions[name]
      }
    })
  }

  renderPaintRefinishTypesAccordion (RefinishTypes) {
    const renderPickerRefinish = (refinishTypes, price) => {
      if (price.OrderEstimationRefinishTypeDetails.length === 0) return null

      const picked = refinishTypes.filter(rt => {
        const rtId = rt.EstimationRefinishTypeId
        return !!price.OrderEstimationRefinishTypeDetails.find(rtd =>
          (rtd.PaintLineId === null && rtd.EstimationRefinishTypeId === rtId)
        )
      })
      if (!picked) return null

      return (
        <div>
          {picked.map((p, key) => {
            return (
              <div className='picked refinish clearfix' key={key}>{p.Type}</div>
            )
          }
          )}
        </div>
      )
    }

    const checkHasAdded = () => {
      let result = false
      this.state.price.OrderEstimationRefinishTypeDetails.map(item => { if (item.PaintLineId === null) result = true })
      return result
    }

    let { price } = this.state
    let { accordions } = this.state

    if (this.props.editable === false && price.OrderEstimationRefinishTypeDetails.length === 0) return null
    if (!this.props.editable && this.props.renderReport !== true && !checkHasAdded()) return null

    return (
      <li key={Math.random()}>
        <div onClick={this.toggleOpen.bind(this, 'refinish' + 1)}>
          <strong className='estimation-accordion__title'>{translation('161')}</strong>
        </div>
        {!accordions['refinish' + 1] && renderPickerRefinish(RefinishTypes, price)}
        {accordions['refinish' + 1] && (
          RefinishTypes.map((item, index) => this.renderRefinishType(null, item, index))
        )}
      </li>
    )
  }

  renderStartTimes (type, reportLine, item, key) {
    if (!reportLine) reportLine = { LineId: null }
    const toggleItem = (e) => {
      if (this.props.editable !== true) return
      let price = { ...this.state.price }
      if (e.target.checked) {
        price.OrderEstimationStartTimeDetails.push({
          EstimationStartTimeId: item.EstimationStartTimeId,
          PaintLineId: reportLine.LineId
        })
      } else {
        price.OrderEstimationStartTimeDetails.map((val) => {
          if (val.EstimationStartTimeId === item.EstimationStartTimeId && val.PaintLineId === reportLine.LineId) {
            val.IsDeleted = true
          }
        })
      }
      this.props.saveOrderPrice(price)
    }
    // Checked
    let checked = false
    const { price } = this.state
    price.OrderEstimationStartTimeDetails.map((val) => {
      if (val.EstimationStartTimeId === item.EstimationStartTimeId && val.PaintLineId === reportLine.LineId) {
        checked = true
      }
    })
    return (
      <Check key={key} labelText={`${item.Type} (${item.Ae} ${translation(885)})`} id={'StartTime_' + type + '_' + item.EstimationStartTimeId} name='StartTime' checked={checked} value={item.EstimationStartTimeId} onChange={toggleItem} />
    )
  }

  renderStartTimeAccordion (StartTimes) {
    const renderPickedStartTime = (startTimes, price) => {
      if (price.OrderEstimationStartTimeDetails.length === 0) return null

      const picked = startTimes.filter(st => {
        const stId = st.EstimationStartTimeId

        return !!price.OrderEstimationStartTimeDetails.find(std =>
          (std.PaintLineId === null && std.EstimationStartTimeId === stId)
        )
      })
      if (!picked) return null

      return (
        <div>
          {picked.map((p, key) => {
            return (
              <div key={key} className='picked starttime clearfix'>
                <div className='left'>{p.Type}</div>
                <div className='right'>({p.Ae} {translation(885)})</div>
              </div>
            )
          }
          )}
        </div>
      )
    }

    const checkHasAdded = () => {
      let result = false
      this.state.price.OrderEstimationStartTimeDetails.map(item => { if (item.PaintLineId === null) result = true })
      return result
    }

    let { price } = this.state
    let { accordions } = this.state
    if (!this.props.editable && price.OrderEstimationStartTimeDetails.length === 0) return null
    if (!this.props.editable && this.props.renderReport !== true && !checkHasAdded()) return null
    return (
      <li key={Math.random()}>
        <div onClick={this.toggleOpen.bind(this, 'starttime1')}>
          <strong className='estimation-accordion__title'>{translation('1195')}</strong>
        </div>
        {!accordions.starttime1 && renderPickedStartTime(StartTimes, price)}
        {accordions.starttime1 && (
          StartTimes.map(this.renderStartTimes.bind(this, null, null))
        )}
      </li>
    )
  }

  renderHourPrices (report, item, key) {
    const toggleItem = (e) => {
      let price = { ...this.state.price }
      price.OrderEstimationHourPriceDetails.map((val) => {
        val.IsDeleted = true
      })
      if (e.target.checked) {
        if (!report) report = { ReportId: null }

        price.OrderEstimationHourPriceDetails.push({
          EstimationHourPriceId: item.EstimationHourPriceId,
          ReportId: report.ReportId
        })
      }
      this.props.saveOrderPrice(price)
    }
    // Checked
    let checked = false
    const { price } = this.state
    price.OrderEstimationHourPriceDetails.map((val) => {
      if (val.EstimationHourPriceId === item.EstimationHourPriceId) {
        checked = true
      }
    })
    return (
      <Check key={key} labelText={`${item.Price}`} id={'HourPrice_' + item.Price} name='HourPrice' checked={checked} value={item.EstimationHourPriceId} onChange={toggleItem} />
    )
  }

  renderHourlyRateAccordion (HourPrices) {
    let { price } = this.state
    let { accordions } = this.state

    const renderPickedHourlyPrice = (hourPrices, price) => {
      if (price.OrderEstimationHourPriceDetails.length === 0) return null

      const picked = hourPrices.find(hp =>
        hp.EstimationHourPriceId === price.OrderEstimationHourPriceDetails[0].EstimationHourPriceId
      )

      if (!picked) return null

      return (
        <div className='picked hourlyprice clearfix'>
          <div className='right'>{picked.Price} {this.props.currencyCode}</div>
        </div>
      )
    }

    if (this.props.editable === false && price.OrderEstimationHourPriceDetails.length === 0) return null
    return (
      <li key={Math.random()}>
        <div onClick={this.toggleOpen.bind(this, 'hourlyprice')}>
          <strong className='estimation-accordion__title'>{translation('419')}</strong>
        </div>
        {!accordions.hourlyprice && renderPickedHourlyPrice(HourPrices, price)}
        {accordions.hourlyprice && (
          <div className='radio__wrapper'>
            {HourPrices.map(this.renderHourPrices.bind(this, null))}
          </div>
        )}
      </li>
    )
  }

  renderMaterialShare (reportLine, item, key) {
    const toggleItem = (e) => {
      let { price } = this.state
      price.OrderEstimationMaterialsShareDetails.map((val) => {
        val.IsDeleted = true
      })
      if (e.target.checked) {
        if (!reportLine) reportLine = { LineId: null }

        price.OrderEstimationMaterialsShareDetails.push({
          EstimationMaterialsShareId: item.EstimationMaterialsShareId,
          PaintLineId: reportLine.LineId
        })
      }
      this.props.saveOrderPrice(price)
    }
    // Checked
    let checked = false
    this.state.price.OrderEstimationMaterialsShareDetails.map((val) => {
      if (val.EstimationMaterialsShareId === item.EstimationMaterialsShareId) {
        checked = true
      }
    })
    return (
      <Check key={key} labelText={`${item.Share}`} id={'MaterialIdx_' + item.Share} name='MaterialShare' checked={checked} value={item.EstimationMaterialsShareId} onChange={toggleItem} />
    )
  }

  renderMaterialIndexAccordion (MaterialsShares) {
    let { price } = this.state
    let { accordions } = this.state

    const renderPickedMaterialIndex = (materialsShares, price) => {
      if (price.OrderEstimationMaterialsShareDetails.length === 0) return null

      const picked = materialsShares.find(ms =>
        ms.EstimationMaterialsShareId === price.OrderEstimationMaterialsShareDetails[0].EstimationMaterialsShareId
      )

      if (!picked) return null

      return (
        <div className='picked matindex clearfix'>
          <div className='right'>{picked.Share}%</div>
        </div>
      )
    }

    if (this.props.editable === false && price.OrderEstimationMaterialsShareDetails.length === 0) return null
    return (
      <li key={Math.random()}>
        <div onClick={this.toggleOpen.bind(this, 'materialshare')}>
          <strong className='estimation-accordion__title'>{translation('415')}</strong>
        </div>
        {!accordions.materialshare && renderPickedMaterialIndex(MaterialsShares, price)}
        {accordions.materialshare && (
          <div className='radio__wrapper'>
            {MaterialsShares.map(this.renderMaterialShare.bind(this, null))}
          </div>
        )}
      </li>
    )
  }

  renderPickedHourlyPrice () {
    if (this.state.price.OrderEstimationHourPriceDetails.length !== 0) {
      let item = this.state.partTasks === undefined ? [] : this.state.partTasks.HourPrices.filter((val) => {
        if (val.EstimationHourPriceId === this.state.price.OrderEstimationHourPriceDetails[0].EstimationHourPriceId) {
          return true
        }
      })
      if (item.length === 0) return null
      return (
        <div className='picked hourlyprice clearfix'>
          <div className='right'>{item[0].Price} {this.props.currencyCode}</div>
        </div>
      )
    }
    return null
  }

  renderPickedMaterialIndex () {
    if (this.state.price.OrderEstimationMaterialsShareDetails.length !== 0) {
      let item = this.state.partTasks === undefined ? [] : this.state.partTasks.MaterialsShares.filter((val) => {
        if (val.EstimationMaterialsShareId === this.state.price.OrderEstimationMaterialsShareDetails[0].EstimationMaterialsShareId) {
          return true
        }
      })
      if (item.length === 0) return null
      return (
        <div className='picked matindex clearfix'>
          <div className='right'>{item[0].Share} %</div>
        </div>
      )
    }
    return null
  }

  renderRefinishType (methodID, item, key) {
    const toggleItem = (e) => {
      let price = { ...this.state.price }
      if (e.target.checked) {
        price.OrderEstimationRefinishTypeDetails.push({
          EstimationRefinishTypeId: item.EstimationRefinishTypeId,
          PaintLineId: methodID
        })
      } else {
        price.OrderEstimationRefinishTypeDetails.map((val) => {
          if (val.EstimationRefinishTypeId === item.EstimationRefinishTypeId && val.PaintLineId === methodID) {
            val.IsDeleted = true
          }
        })
      }
      this.props.saveOrderPrice(price)
    }
    // Checked
    let checked = false
    const { price } = this.state
    price.OrderEstimationRefinishTypeDetails.map((val) => {
      if (val.EstimationRefinishTypeId === item.EstimationRefinishTypeId && val.PaintLineId === methodID) {
        checked = true
      }
    })
    return (
      <Check key={key} labelText={item.Type} id={'RefinishType_' + methodID + '_' + item.EstimationRefinishTypeId} name='RefinishType' checked={checked} value={item.EstimationRefinishTypeId} onChange={toggleItem.bind(this)} />
    )
  }

  renderForForsi () {
    const shouldRenderStrikeThrough = (type, key) => {
      let found = false
      switch (type) {
        case 'refinish':
          this.state.price.OrderEstimationRefinishTypeDetails.map((val) => {
            if (val.PaintLineId === key) {
              found = true
            }
          })
          break
        case 'starttime':
          this.state.price.OrderEstimationStartTimeDetails.map((val) => {
            if (val.ReportLineSubType === key) {
              found = true
            }
          })
          break
        case 'materialshare':
          if (this.state.price.OrderEstimationMaterialsShareDetails.length !== 0) found = true
          break
        case 'hourlyprice':
          if (this.state.price.OrderEstimationHourPriceDetails.length !== 0) found = true
          break
      }

      return found
      // if (found) {
      //   return <div className='strike_through' />
      // }
      // return null
    }

    const renderPickedStartTime = (id) => {
      if (this.state.price.OrderEstimationStartTimeDetails.length !== 0) {
        let picked = JSON.parse(JSON.stringify(this.state.price.OrderEstimationStartTimeDetails)).filter((val) => {
          return val.ReportLineSubType === id
        })
        if (picked.length === 0) return null
        const renderItem = (v, k) => {
          let item = this.state.partTasks === undefined ? [] : this.state.partTasks.StartTimes.filter((val) => {
            return val.EstimationStartTimeId === v.EstimationStartTimeId
          })
          if (item.length === 0) return null
          return (
            <div className='picked starttime clearfix' key={k}>
              <div className='left'>{item[0].Type}</div>
              <div className='right'>{item[0].Ae + ' ' + translation(885)}</div>
            </div>
          )
        }
        return (
          <div>
            {picked.map(renderItem)}
          </div>
        )
      }
      return null
    }

    const renderMethod = (item, key) => {
      let { price, partTasks, accordions } = this.state
      const renderPickerRefinish = (methodID) => {
        if (price.OrderEstimationRefinishTypeDetails.length !== 0) {
          let picked = price.OrderEstimationRefinishTypeDetails.filter((val) => {
            return val.PaintLineId === methodID
          })
          if (picked.length === 0) return null
          const renderPicked = (val, k) => {
            let item = partTasks === undefined ? [] : partTasks.RefinishTypes.filter((v) => {
              return v.EstimationRefinishTypeId === val.EstimationRefinishTypeId
            })
            if (item.length === 0) return null
            return (
              <div key={k}>
                {item[0].Type}
              </div>
            )
          }
          return (
            <div>
              {picked.map(renderPicked)}
            </div>
          )
        }
        return null
      }

      const methodClasses = shouldRenderStrikeThrough('refinish', item.LineId) ? 'estimation-extents__forsi-method--strike_through' : ''
      return (
        <li className={methodClasses} key={Math.random()}>
          {<ForsiLine method={{ Name: item.LineText, Code: item.LineNumber, AE: item.WorkUnits }} onClick={this.toggleOpen.bind(this, 'refinish' + key)} />}
          {!accordions['refinish' + key] && renderPickerRefinish(item.LineId)}
          {accordions['refinish' + key] && (
            partTasks.RefinishTypes.map((item, index) => this.renderRefinishType(item.LineId, item, index))
          )}
        </li>
      )
    }

    const renderPart = (item) => {
      // console.log('renderPart: ', item)
      let extraCSS = this.state.activeTaskId === item.LineId ? 'active' : ''
      const onClick = () => {
        let taskId = (this.state.activeTaskId === 0 || this.state.activeTaskId !== item.LineId) ? item.LineId : 0
        this.setState({
          activeTaskId: taskId
        })
        // Call event to store ID until something is added
        EventEmitter.emit('pricecalc_activeitem', taskId)
      }
      const renderSelectedItem = (getBack) => {
        let items = []
        this.state.price.Parts.map((val) => {
          val.EstimationTasks.map((v) => {
            if (v.PaintLineId === item.LineId) {
              items.push(v)
            }
          })
        })
        if (getBack) return items.length
        if (items.length === 0) return null

        return (
          <ul className='selectedItem added'>
            {items.map((item, k) => {
              return <EstimationLine
                key={k + '_' + item.OrderEstimationTaskId}
                orderEstimationTask={item}
                onDelete={this.props.editable !== true ? undefined : this.props.onDelete && this.props.onDelete.bind(this, item.OrderEstimationTaskId)}
                currencyCode={this.props.currencyCode}
              />
            })}
          </ul>
        )
      }

      const hasSelectedItems = renderSelectedItem(true) !== 0
      if (extraCSS !== '' && hasSelectedItems) {
        onClick()
      }
      if (hasSelectedItems) {
        extraCSS += ' estimation-extents__forsi-part--strike_through'
      }

      let showAE = this.props.order && this.props.order.ShowAE
      let showPrices = this.props.order && this.props.order.ShowPrices

      return (
        <li key={Math.random()} className={'clearfix ' + extraCSS} onClick={hasSelectedItems ? null : onClick}>
          {<AssessmentForsiLine line={item} currencyCode={this.props.currencyCode} showAE={showAE} showPrices={showPrices} />}
          {/* <ForsiLine part={{Method: item.AdditionalLineText, Name: item.LineText, AE: item.WorkUnits}} /> */}
          {hasSelectedItems && (<div className='strike_through' />)}
          {renderSelectedItem()}
        </li>
      )
    }

    const REPORT_GENERIC_LINETYPE = 0
    const REPORT_WORK_LINETYPE = 1
    const REPORT_STARTTIME_LINETYPE = 4

    const REPORT_MATERIALINDEX_LINESUBTYPE = 1
    const REPORT_REFINISH_LINESUBTYPE = 6

    const renderStarttime = (number) => {
      let startTimeLines = this.state.price.Report.Paint.Lines.filter(l => l.LineType === REPORT_STARTTIME_LINETYPE && l.LineSubType === number)
      if (startTimeLines.length === 0) return

      // For now assume max one starttime line for each type, so we just take the first.
      let reportStartTimeLine = startTimeLines[0]
      let startTimeValue = reportStartTimeLine.WorkUnits
      let startTimeName = reportStartTimeLine.LineText

      const startTimeClasses = shouldRenderStrikeThrough('starttime', number) ? ' strike_through' : ''

      return (
        <li className='estimation-starttime-grouping' key={'starttime_type_' + number}>
          <div className='estimation-accordion-line' onClick={this.toggleOpen.bind(this, 'starttime' + number)}>
            <strong className='estimation-accordion__title'>{startTimeName}</strong>
            <div className={'estimation-accordion__value' + startTimeClasses}>{startTimeValue || 0} {translation('885')}</div>
          </div>
          {!this.state.accordions['starttime' + number] && renderPickedStartTime(number)}
          {this.state.accordions['starttime' + number] && (
            this.state.partTasks === undefined ? null : this.state.partTasks.StartTimes.map(this.renderStartTimes.bind(this, number, reportStartTimeLine))
          )}
        </li>
      )
    }

    const hourlyPriceClasses = shouldRenderStrikeThrough('hourlyprice') ? ' strike_through' : ''
    const materialShareClasses = shouldRenderStrikeThrough('materialshare') ? ' strike_through' : ''

    let css = 'forsiExtent'
    if (this.props.editable !== true) css += ' show'

    let reportWorkLines
    let reportRefinishLines
    let reportMaterialIndexLines
    let startTimeTypes
    let hourPrice

    if (this.state.price.Report.Paint) {
      const { Lines, HourPrice } = this.state.price.Report.Paint

      reportWorkLines = Lines.filter(l => l.LineType === REPORT_WORK_LINETYPE)
      reportRefinishLines = Lines.filter(l => l.LineType === REPORT_GENERIC_LINETYPE && l.LineSubType === REPORT_REFINISH_LINESUBTYPE)
      reportMaterialIndexLines = Lines.filter(l => l.LineType === REPORT_GENERIC_LINETYPE && l.LineSubType === REPORT_MATERIALINDEX_LINESUBTYPE)
      startTimeTypes = uniq(Lines.filter(l => l.LineType === REPORT_STARTTIME_LINETYPE).map(l => l.LineSubType))
      hourPrice = HourPrice
    }

    let materialIndexLine = reportMaterialIndexLines && reportMaterialIndexLines.length > 0 ? reportMaterialIndexLines[0] : null

    return (
      <ul className={css}>
        {reportWorkLines && reportWorkLines.map(renderPart)}
        {reportRefinishLines && reportRefinishLines.length !== 0
          ? reportRefinishLines.map(renderMethod)
          : this.renderPaintRefinishTypesAccordion(this.state.partTasks === undefined ? [] : this.state.partTasks.RefinishTypes)}
        {startTimeTypes && startTimeTypes.map(t => renderStarttime(t))}
        <li className='clearfix'>
          <div className='estimation-accordion-line' onClick={this.toggleOpen.bind(this, 'hourlyprice')}>
            <strong className='estimation-accordion__title'>{translation('419')}</strong>
            <div className={'estimation-accordion__value' + hourlyPriceClasses}>{hourPrice || 0} {this.props.currencyCode}</div>
          </div>
          {!this.state.accordions.hourlyprice && this.renderPickedHourlyPrice()}
          {this.state.accordions.hourlyprice && (
            <div className='radio__custom__wrapper'>
              {this.state.partTasks === undefined ? null : this.state.partTasks.HourPrices.map(this.renderHourPrices.bind(this, this.state.price.Report))}
            </div>
          )}
        </li>
        <li className='clearfix'>
          <div className='estimation-accordion-line' onClick={this.toggleOpen.bind(this, 'materialshare')}>
            <strong className='estimation-accordion__title'>{translation('415')}</strong>
            <div className={'estimation-accordion__value' + materialShareClasses}>{materialIndexLine ? materialIndexLine.GenericValue : 0}</div>
          </div>
          {!this.state.accordions.materialshare && this.renderPickedMaterialIndex()}
          {this.state.accordions.materialshare && (
            <div className='radio__custom__wrapper'>
              {this.state.partTasks === undefined ? null : this.state.partTasks.MaterialsShares.map(this.renderMaterialShare.bind(this, materialIndexLine))}
            </div>
          )}
        </li>
        {!this.props.editable && <Divider />}
        {!this.props.editable && (
          <li className='clearfix'>
            <AssessmentReportSums report={this.state.price.Report} department={this.state.price.Department} currencyCode={this.props.currencyCode} includeTotal />
          </li>
        )}
      </ul>
    )
  }

  render () {
    let hasReport = this.state.price.Report !== null && this.state.price.Report.ReportId !== 0
    let css = 'forsiExtent'
    if (this.props.editable !== true) css += ' show'
    if (!this.state.partTasks || !this.state.price) return null
    if (this.state.price.Report && typeof this.state.price.Report === 'object' && this.props.renderReport === true) {
      return this.renderForForsi()
    } else {
      const { RefinishTypes, StartTimes, HourPrices, MaterialsShares } = this.state.partTasks
      return (
        <ul className={css + ' added'}>
          {RefinishTypes.length !== 0 && this.renderPaintRefinishTypesAccordion(RefinishTypes)}
          {StartTimes.length !== 0 && this.renderStartTimeAccordion(StartTimes)}
          {HourPrices.length !== 0 && !hasReport && this.renderHourlyRateAccordion(HourPrices)}
          {MaterialsShares.length !== 0 && !hasReport && this.renderMaterialIndexAccordion(MaterialsShares)}
        </ul>
      )
    }
  }
}

export default EstimationExtents



// WEBPACK FOOTER //
// ./src/app/shared/components/Extent/Estimation/EstimationExtents/index.js